//时间戳转换成日期
export function dateFilter(time) {
    if (!time) {
        // 当时间是null或者无效格式时我们返回空
        return ''
    } else {
        const date = new Date(time) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000

        const dateNumFun = (num) => num < 10 ? `0${num}` : num // 使用箭头函数和三目运算以及es6字符串的简单操作。因为只有一个操作不需要{} ，目的就是数字小于10，例如9那么就加上一个0，变成09，否则就返回本身。        // 这是es6的解构赋值。
        const [Y, M, D, h, m, s] = [
            date.getFullYear(),
            dateNumFun(date.getMonth() + 1),
            dateNumFun(date.getDate()),
            dateNumFun(date.getHours()),
            dateNumFun(date.getMinutes()),
            dateNumFun(date.getSeconds())
        ]
        return `${Y}-${M}-${D} ${h}:${m}:${s}` // 一定要注意是反引号，否则无效。
    }

}

// 时间戳转换成日期 （13位毫秒）
export function dateFormat(dateData) {
    // console.log(dateData);//1605024000000
    let date = new Date(dateData); //Wed Nov 11 2020 00:00:00 GMT+0800 (中国标准时间)
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}

// 时间戳转换成日期 （年月日时分之间用.分割）
export function datetime(dateData) {
    // console.log(dateData);//1605024000000
    let date = new Date(dateData); //Wed Nov 11 2020 00:00:00 GMT+0800 (中国标准时间)
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return y + '.' + MM + '.' + d + ' ' + h + ':' + m;
}



//时间戳转换成日期 yyyy-MM-DD
export function dateFilte(time) {
    if (!time) {
        // 当时间是null或者无效格式时我们返回空
        return ''
    } else {
        const date = new Date(time) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000

        const dateNumFun = (num) => num < 10 ? `0${num}` : num // 使用箭头函数和三目运算以及es6字符串的简单操作。因为只有一个操作不需要{} ，目的就是数字小于10，例如9那么就加上一个0，变成09，否则就返回本身。        // 这是es6的解构赋值。
        const [Y, M, D] = [
            date.getFullYear(),
            dateNumFun(date.getMonth() + 1),
            dateNumFun(date.getDate()),
        ]
        return `${Y}-${M}-${D}` // 一定要注意是反引号，否则无效。
    }

}
// 获取当前时间 返回时间戳
export function getTimeDate() {
    const thisTime = new Date();
    let month = thisTime.getMonth() + 1;
    let ao = month < 10 ? '0' + month : month;
    let day = thisTime.getDate() < 10 ? '0' + thisTime.getDate() : thisTime.getDate();
    let hh = thisTime.getHours() < 10 ? '0' + thisTime.getHours() : thisTime.getHours();
    let mm = thisTime.getMinutes() < 10 ? '0' + thisTime.getMinutes() : thisTime.getMinutes();
    let ss = thisTime.getSeconds() < 10 ? '0' + thisTime.getSeconds() : thisTime.getSeconds();
    let thisDataTime = new Date(thisTime.getFullYear() + '/' + ao + '/' + day + ' ' + hh + ':' + mm + ':' + ss).getTime();
    return thisDataTime
}
// 获取当前时间 返回日期
export function getTimeDateCopy() {
    const thisTime = new Date();
    let month = thisTime.getMonth() + 1;
    let ao = month < 10 ? '0' + month : month;
    let day = thisTime.getDate() < 10 ? '0' + thisTime.getDate() : thisTime.getDate();
    let hh = thisTime.getHours() < 10 ? '0' + thisTime.getHours() : thisTime.getHours();
    let mm = thisTime.getMinutes() < 10 ? '0' + thisTime.getMinutes() : thisTime.getMinutes();
    let ss = thisTime.getSeconds() < 10 ? '0' + thisTime.getSeconds() : thisTime.getSeconds();
    let thisDataTime = {
        date: thisTime.getFullYear() + '/' + ao + '/' + day,
        hhmmss: hh + ':' + mm + ':' + ss
    }
    return thisDataTime
}
// 根据日期计算出星期几
export function getweekday(date) {
    let obj = {
        stringWeek: '',//（星期三）
        stringWeeka: '',//（每周三）
        numWeek: '',//（三）
        num: ''//(123)
    }
    let weekArray = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
    let weekArraynuma = new Array("每周日", "每周一", "每周二", "每周三", "每周四", "每周五", "每周六");
    let weekArraynum = new Array("日", "一", "二", "三", "四", "五", "六");
    let num = new Array("7", "1", "2", "3", "4", "5", "6");
    obj.stringWeek = weekArray[new Date(date).getDay()];// 注意此处必须是先new一个Date
    obj.stringWeeka = weekArraynuma[new Date(date).getDay()];// 注意此处必须是先new一个Date
    obj.numWeek = weekArraynum[new Date(date).getDay()];// 注意此处必须是先new一个Date
    obj.num = num[new Date(date).getDay()];// 注意此处必须是先new一个Date
    return obj;
}
// 根据当前日期 加数字天数（20） 返回二十天的日期
export function thisDataCalculate(creat, numday) {
    let dd = new Date(creat);// creat 计算日期的起始时间（2021-12-27）/（2021-12-27 12:02:00）
    dd.setDate(dd.getDate() + numday);//获取numday天后的日期
    let y = dd.getFullYear();
    let m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
    let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
    //return y+"-"+m+"-"+d;年月日
    //y+"-"+m+"-"+d月日
    // console.log(y+"-"+m+"-"+d);
    return y + "-" + m + "-" + d
}
// 获取本年 / 本月
export function month() {
    let date = new Date();
    return {
        year: date.getFullYear(), //年
        month: date.getMonth() + 1, // 月
    }
}
// 获取指定月份的天数
export function getCurrentMonthLasta(data) {
    var date = new Date(data);
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    var lastTime = new Date(nextMonthFirstDay - oneDay);
    var month = parseInt(lastTime.getMonth() + 1);
    var day = lastTime.getDate();
    if (month < 10) {
        month = '0' + month
    }
    if (day < 10) {
        day = '0' + day
    }
    // date.getFullYear() + '-' + month + '-' +day （2022-02-01）
    return day;

}
// 获取指定月份的上月天数 列 指定月份为5月  此处获取的则是 4月份天数
// MM 传来的时候做好-1处理
export function getCurrentMonthLast(YY, MM) {
    let data = '';
    // console.log(YY, MM)
    MM = MM < 10 ? '0' + MM : MM;
    if (MM < 1) {
        --YY
        MM = 12;
        data = YY + '-' + MM + '-01' + ' 00:00:00';
    } else {
        data = YY + '-' + MM + '-01' + ' 00:00:00';
    }
    console.log(data)
    var date = new Date(data);
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    var lastTime = new Date(nextMonthFirstDay - oneDay);
    var month = parseInt(lastTime.getMonth() + 1);
    var day = lastTime.getDate();
    if (month < 10) {
        month = '0' + month
    }
    if (day < 10) {
        day = '0' + day
    }
    // date.getFullYear() + '-' + month + '-' +day （2022-02-01）
    return day;

}
// 两个日期时间比较 同一天返回一个日期加时间  不同天显示两个日期加时间
export function getfairly(startTime, endTime) {
    // splice
    // console.log(startTime,endTime);
    let start = startTime.split(' ')[0]
    let end = endTime.split(' ')[0]
    let startyd = startTime.split(' ')[1]
    let endyd = endTime.split(' ')[1]
    // 把秒去掉
    if (start == end) {
        return start + ' ' + startyd.substring(0, startyd.length - 3) + ' - ' + endyd.substring(0, endyd.length - 3)
    } else {
        return startTime.substring(0, startTime.length - 3) + ' - ' + endTime.substring(0, endTime.length - 3)
    }
}

// 聊天时间戳转换成日期 
export function dayjudge(time) {
    if (time == '') {
        return ''
    }
    let timeDate = +new Date()
    timeDate = dateFormat(timeDate)
    time = dateFormat(time)

    let start = timeDate.split(' ')[0]
    let startyd = time.split(' ')[0]

    // 把秒去掉
    if (start == startyd) {//当天不显示日期        
        return time.split(' ')[1].substring(0, time.split(' ')[1].length - 3)
    } else {
        return time.substring(0, time.length - 3)
    }

}
// 秒数转换分钟 秒
export function CountDown(seconds) {
    console.log(seconds);
    if (isNaN(seconds)) {
        return {
            day: '00时00:00分00秒',// 天 小时  分 秒
            hh: '00:00' // 分 秒
        }
    } else {
        // var dd = new Date;
        let d = parseInt(seconds / (24 * 60 * 60));
        d = d < 10 ? "0" + d : d;
        let h = parseInt(seconds / (60 * 60) % 24);
        h = h < 10 ? "0" + h : h;
        let m = parseInt(seconds / 60 % 60);
        m = m < 10 ? "0" + m : m;
        let s = parseInt(seconds % 60);//dd.getSeconds()
        s = s < 10 ? "0" + s : s;
        let day = d == '00' ? '' : d + '天';
        return {
            day: day + h + '时' + m + '分' + s + '秒',// 天 小时  分 秒
            hh: m + ':' + s // 分 秒
        }
    }
}
// 年月日转换  2022年10月14日
export function CountDownWen(seconds) {
    if (seconds) {
        let dateName = seconds.split('-')
        let n = parseInt(dateName[0]);
        let y = parseInt(dateName[1]);
        let r = parseInt(dateName[2]);
        return `${n}年${y}月${r}日 `
    }
}
//   年月日
export function CountDownWenAUto() {
    const thisTime = new Date();
    let month = thisTime.getMonth() + 1;
    let ao = month < 10 ? '0' + month : month;
    let day = thisTime.getDate() < 10 ? '0' + thisTime.getDate() : thisTime.getDate();
    // let hh = thisTime.getHours() < 10 ? '0' + thisTime.getHours() : thisTime.getHours();
    // let mm = thisTime.getMinutes() < 10 ? '0' + thisTime.getMinutes() : thisTime.getMinutes();
    // let ss = thisTime.getSeconds() < 10 ? '0' + thisTime.getSeconds() : thisTime.getSeconds();
    let thisDataTime = thisTime.getFullYear() + '年' + ao + '月' + day + '日'
    return thisDataTime
}

//时间戳转换成日期 yyyy/MM/DD
export function dateFiltezhx(time) {
    if (!time) {
        // 当时间是null或者无效格式时我们返回空
        return ''
    } else {
        const date = new Date(time) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000

        const dateNumFun = (num) => num < 10 ? `0${num}` : num // 使用箭头函数和三目运算以及es6字符串的简单操作。因为只有一个操作不需要{} ，目的就是数字小于10，例如9那么就加上一个0，变成09，否则就返回本身。        // 这是es6的解构赋值。
        const [Y, M, D, h, m, s] = [
            date.getFullYear(),
            dateNumFun(date.getMonth() + 1),
            dateNumFun(date.getDate()),
            dateNumFun(date.getHours()),
            dateNumFun(date.getMinutes()),
            dateNumFun(date.getSeconds())
        ]
        // :${s}
        return `${Y}/${M}/${D} ${h}:${m}` // 一定要注意是反引号，否则无效。
    }

}
// 阿拉伯数字转换大写
export function numberParseChina(n) {
    var cnum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
    var s = '';
    n = '' + n; // 数字转为字符串
    for (var i = 0; i < n.length; i++) {
        s += cnum[parseInt(n.charAt(i))];
    }
    if (s.length == 2) { // 两位数的时候
        // 如果个位数是0的时候，0改成十
        if (s.charAt(1) == cnum[0]) {
            s = s.charAt(0) + cnum[10];
            // 如果是一十改成十
            if (s == cnum[1] + cnum[10]) {
                s = cnum[10]
            }
        } else if (s.charAt(0) == cnum[1]) {
            // 如果十位数是一的话改成十
            s = cnum[10] + s.charAt(1);
        } else if (s.charAt(0) == cnum[2]) {
            // 如果十位数是二的话改成十二
            s = cnum[2] + cnum[10] + s.charAt(1);
        } else if (s.charAt(0) == cnum[3]) {
            s = cnum[3] + cnum[10] + s.charAt(1);
        } else if (s.charAt(0) == cnum[4]) {
            s = cnum[4] + cnum[10] + s.charAt(1);
        } else if (s.charAt(0) == cnum[5]) {
            s = cnum[5] + cnum[10] + s.charAt(1);
        } else if (s.charAt(0) == cnum[6]) {
            s = cnum[6] + cnum[10] + s.charAt(1);
        } else if (s.charAt(0) == cnum[7]) {
            s = cnum[7] + cnum[10] + s.charAt(1);
        } else if (s.charAt(0) == cnum[8]) {
            s = cnum[8] + cnum[10] + s.charAt(1);
        } else if (s.charAt(0) == cnum[9]) {
            s = cnum[9] + cnum[10] + s.charAt(1);
        } else if (s.charAt(0) == cnum[10]) {
            s = cnum[10] + cnum[10] + s.charAt(1);
        }

    }
    return s;
}



// WEBPACK FOOTER //
// ./src/utils/time.js